import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-payments-reports-nb-transactions-amount-card',
  templateUrl: './payments-reports-nb-transactions-amount-card.component.html',
  styleUrls: ['./payments-reports-nb-transactions-amount-card.component.scss']
})
export class PaymentsReportsNbTransactionsAmountCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
